/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const PlantSeedlingBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6.48 7.15C5.967 6.77 5.47 6.147 5.203 5H7c1.335 0 2.258.515 2.89 1.302.359.447.651 1.02.846 1.698H10c-1.62 0-2.77-.3-3.52-.85Zm6.143.18C11.853 4.789 9.921 3 7 3H4c-.552 0-1.005.449-.963 1C3.4 8.695 6.38 10 10 10h1V13.063a7.999 7.999 0 0 0-6.938 6.94c-.069.548.386.997.938.997h14c.552 0 1.006-.45.938-.997A8 8 0 0 0 13 13.063V12h1.675c3.25 0 5.921-1.726 6.277-6 .045-.55-.408-1-.96-1h-2.628c-1.884 0-3.576.9-4.74 2.33Zm.735 2.67h1.316c1.285 0 2.255-.339 2.918-.911.48-.414.927-1.062 1.181-2.089h-1.41c-1.683 0-3.306 1.166-4.005 3ZM12 15a6 6 0 0 0-5.657 4h11.314a5.995 5.995 0 0 0-3.361-3.543A6 6 0 0 0 12 15Z" /></svg>);
const PlantSeedling = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={PlantSeedlingBase} {...rest} ref={ref} />);
export default PlantSeedling;